import React from "react";
import { useSelector } from "react-redux";
import SportCard from './SportCard';
import { sportStyle as styles } from "./sport.tailwind";
import { getSportCourtImage } from "../../pages/SportPage/sportPageData";

const SelectSportOptions = () => {
  const { seasons } = useSelector(state => state.seasons)

  return (
    <div className={styles.container}>
      {/* All Sports/Seasons */}

      {seasons.map((sportSeason, key) => (
        <SportCard
          key={key}
          sport={sportSeason}
          backgroundImage={getSportCourtImage(sportSeason?.seasonCode)}
        />
      ))}
    </div>
  );
};

export default SelectSportOptions